export default __webpack_public_path__ + "static/media/gallery_01.b0c04881.jpg";